import { render, staticRenderFns } from "./LpPortfolioInformations.vue?vue&type=template&id=291f1f50"
import script from "./LpPortfolioInformations.vue?vue&type=script&lang=js"
export * from "./LpPortfolioInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports